(function () {
    'use strict';

    angular.module("imApp").factory("kpiCompsService", [function () {
        let service = {};

        return service;
    }]);
})();
